"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DemoCardsContainer_1 = require("./DemoCardsContainer");
exports.default = DemoCardsContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectionPanel/components/DemoCardsContainer/index.js
// module id = 1411
// module chunks = 8